<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    :disabled="disabled"
  >
    <template v-slot:activator="{on: menu, attrs}">
      <v-tooltip :disabled="!tooltip">
        <template v-slot:activator="{on: onTooltip}">
          <v-text-field
            v-model="formattedDate"
            :dense="dense"
            :error-messages="errorMessages"
            :label="labelText"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            :single-line="!date"
            v-on="{...onTooltip, ...menu}"
          />
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      locale="ru-ru"
      first-day-of-week="1"
      @input="onDatePickerChanged"
    >
      <v-btn
        v-if="resetable"
        class="px-4"
        outlined
        @click.prevent="clearClick"
      >
        Сбросить
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    tooltip: { type: String, default: "" },
    dense: { type: Boolean, default: false },
    resetable: { type: Boolean, default: false },
    errorMessages: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data: () => ({
    date: "",
    dateMenu: false,
    formattedDate: ""
  }),

  computed: {
    labelText: function () {
      return this.label ? this.label : "Дата"
    }
  },

  watch: {
    value: function (val) {
      this.date = val.substring(0, 10)
    },
    date: function (val) {
      this.formattedDate = this.getDDMMYYYY(val)
    }
  },

  mounted() {
    if (this.value) {
      this.date = this.value?.substring(0, 10)
    }
  },

  methods: {
    onDatePickerChanged(val) {
      this.dateMenu = false
      this.$emit("input", val)
    },

    getDDMMYYYY(val) {
      if (val && val.length >= 10) {
        const date = val.substring(0, 10)
        return date.slice(8, 10) + "." + date.slice(5, 7) + "." + date.slice(0, 4)
      }
      return ""
    },

    clearClick() {
      this.date = ""
      this.dateMenu = false
      this.$emit("input", this.date)
    }
  }
}
</script>
